import { Box, Button, Grid2, Slider, Stack, Typography, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Modal, Nav, Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Icon from "../../../../Icon/Icon";
import { parseDateToLgComun2, validInitDates } from "../../../../../helpers/dateTransform";

const tabs = [
  {
    key: "all",
    name: "Todos los archivos",
  },
  {
    key: "images",
    name: "Imágenes",
    formats: ["jpg", "jpeg", "png"]
  },
  {
    key: "documents",
    name: "Documentos",
    formats: ["pdf","vnd.openxmlformats-officedocument.wordprocessingml.document"]
  },
  {
    key: "audios",
    name: "Audios",
    formats: ["mpeg", "mp3"]
  },
  {
    key: "videos",
    name: "Videos",
    formats: ["3gp", "mp4"]
    // disabled: true
  },
];

const icons = {
  all: "category",
  audios: "music",
  images: "gallery",
  videos: "outline_video",
  documents: "outline_document_text",
  pdf: "pdf"
}

// Content of confirmation modal
export const ComplementsModal = ({
  show,
  onHide,
  complements,
}) => {

  const [t] = useTranslation("information")
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState("all");
  const [scale, setScale] = useState(1);
  const [attachments, setAttachments] = useState([]);
  const [selectedAttachment, setSelectedAttachment] = useState(null);
  const [isLoading, setIsLoading] = useState();

  useEffect(() => {
    setIsLoading(true);
    if (Array.isArray(complements)) {
      setAttachments(complements);
    }
    setIsLoading(false);
  }, [complements]);

  useEffect(() => {
    handleSelectedAttachment(null);
  }, [show]);

  // Función para manejar el zoom
  // const handleZoom = (_, newValue) => {
  //   setScale(newValue);
  // };

  // Función para resetear la imagen
  // const resetImage = () => {
  //   setScale(1); // Resetear el zoom a 1
  // };

  const returnAttachmentsByType = (formats) => {
    if (!formats) return attachments;
    return attachments?.filter(item=>formats.includes(item.file_type));
  }

  const returnDisabledTab = (formats) => {
    if (!formats) return false;
    const newAttachments = attachments?.filter(item=>formats.includes(item.file_type))
    return newAttachments.length === 0 ? true : false;
  }
  
  const returnTabName = (key) => {
    if (key === "all") return t("information.all");
    if (key === "images") return t("information.images");
    if (key === "documents") return t("information.documents");
    if (key === "audios") return t("information.audios");
    if (key === "videos") return t("information.videos");
    return ""
  }

  const handleSelectedAttachment = (attachment) => {
    setSelectedAttachment(attachment);
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="complementsModal"
      backdropClassName="complementsModal-backdrop"
      dialogClassName="complementsModal-dialog"
    >
      <Modal.Header>
        <Box>
          <Typography 
            fontWeight={700} 
            color="pink" 
            fontSize={28}
            paddingTop={1.1}
            paddingLeft={1.8}
          >
            {t("information.report_complements")}
          </Typography>
        </Box>
        <Stack>
          <Nav className="nav-mobile">
            {
              tabs.map(tab=>(
                <Nav.Item key={tab.key}>
                  <Nav.Link 
                    onClick={() => setActiveTab(tab.key)} 
                    className={activeTab === tab.key ? "active" : ""} 
                    // disabled={tab?.disabled} 
                    disabled={returnDisabledTab(tab.formats)} 

                  >
                    <Icon 
                      name={icons[tab.key]}
                      color={activeTab === tab.key ? theme.palette.ethicsBlue.main : theme.palette.secondary.main}
                    />
                  </Nav.Link>
                </Nav.Item>
              ))
            }
          </Nav>
          <Nav className="nav-desktop">
            {
              tabs.map(tab=>(
                <Nav.Item key={tab.key}>
                  <Nav.Link 
                    onClick={() => setActiveTab(tab.key)} 
                    className={activeTab === tab.key ? "active" : ""} 
                    // disabled={tab?.disabled} 
                    disabled={returnDisabledTab(tab.formats)} 

                  >
                    {returnTabName(tab.key)}
                  </Nav.Link>
                </Nav.Item>
              ))
            }
          </Nav>

          {/* <Box
            sx={{
              
              width: "80%",
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Slider
              value={scale}
              min={1}
              max={2}
              step={0.25}
              onChange={handleZoom}
              size="small"
              sx={{
                flex: 1,
              }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={resetImage}
            >
              Reset
            </Button>
          </Box> */}

        </Stack>
      </Modal.Header>

      <Modal.Body>
        <Box className="folder">

          <Box 
            display="flex"
            flexWrap="wrap"
            gap={1}
            alignContent="flex-start"
            height="100%"
            overflow="auto"
          >
            <Tab.Container activeKey={activeTab} onSelect={setActiveTab}>
              <Tab.Content>
                {
                  tabs.map(tab=>(
                    <Tab.Pane key={tab.key} eventKey={tab.key}>
                      <FolderComponent 
                        data={returnAttachmentsByType(tab.formats)} 
                        handleSelectedAttachment={handleSelectedAttachment}
                      />
                    </Tab.Pane>
                  ))
                }
              </Tab.Content>
            </Tab.Container>
          </Box>

          <Box
            className="details" 
            size={4} 
            height="100%"
            overflow="auto"
          >
            <DetailsComponent selectedAttachment={selectedAttachment} scale={scale} />
          </Box>
        </Box>

      </Modal.Body>
    </Modal>
  );
};

const FolderComponent = ({ data, handleSelectedAttachment }) => {
  return (
    <Box
      size={8} 
      padding={2}
      display="flex"
      flexWrap="wrap"
      gap={1}
      alignContent="flex-start"
      height="100%"
      overflow="auto"
    >
    {
      Array.isArray(data) && data.map((item, idx) => (
        <ArchiveComponent
          key={idx}
          handleSelectedAttachment={handleSelectedAttachment}
          {...item} 
        />
      ))
    }
    </Box>
  )
}

const ArchiveComponent = ({ handleSelectedAttachment, ...props }) => {
  
  const theme = useTheme();
  const keyOfSelected = tabs.find(item=>item?.formats?.includes(props?.file_type))?.key || "documents";
  const forceIcon = props.file_type === "pdf" ? "pdf" : null;
  const isImage = keyOfSelected === "images";

  return (
    <Box
      onClick={() => handleSelectedAttachment(props)}
      onDoubleClick={() => window.open(props.file)}
      sx={{
        height: "100px",
        width: "100px",
        border: `1px solid ${theme.palette.blueGray600.main}`,
        borderRadius: "5px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        backgroundColor: theme.palette.blueGray100.main,
        cursor: "pointer",
        padding: 1,
        ...(props.thumb && {
          backgroundImage: `url(${props.thumb});`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        })

      }}
    >
      {
        !isImage && 
        <>
          <Icon name={forceIcon ? icons[forceIcon] : icons[keyOfSelected]} color={theme.palette.secondary.main} size={24} />
          <Typography fontSize={12} fontWeight={600} sx={{ overflow: "hidden", display: "-webkit-box", WebkitBoxOrient: "vertical", WebkitLineClamp: 1, width: "100%"}}>
            {props.name}
          </Typography>
          <Typography fontSize={12} fontWeight={300}>
            {props.type}
          </Typography>
        </>
      }
    </Box>
  )
}

const DetailsComponent = ({ selectedAttachment, scale }) => {

  const [t] = useTranslation("information")
  const theme = useTheme();
  const keyOfSelected = tabs.find(item=>item.formats?.includes(selectedAttachment?.file_type))?.key ?? "documents";
  const forceIcon = selectedAttachment?.file_type === "pdf" ? "pdf" : null;

  const metadataStyles = {
    color: "oxfordBlue" ,
    fontSize: 12, 
    fontWeight: 300,
  }

  return (
    <Box
      sx={{
        borderLeft: `2px solid ${theme.palette.blueGray600.main}`,
        backgroundColor: theme.palette.blueGray50.main,
        padding: "16px 18px 8px 20px",
        height: "100%",
        overflow: "auto"
      }}
    >
      <Typography color="secondary" fontSize={12} fontWeight={600} marginBottom={.8}>
        {t("information.file_details")}
      </Typography>
      {
        !selectedAttachment ? (
          <Typography fontSize={16} color="oxfordBlue" borderBottom={`1px solid ${theme.palette.blueGray200.main}`}>
            {t("information.no_selected_file")}
          </Typography>
        ) : (
          <>
            {
              selectedAttachment?.thumb &&
              <ImagePreview scale={scale} src={selectedAttachment?.thumb} /> 
            }
            <Stack direction="row" spacing={1.8} >
              {
                !selectedAttachment?.thumb 
                ? <Box width={36} >
                    <Icon name={forceIcon ? icons[forceIcon] : icons[keyOfSelected]} size={24} color={theme.palette.secondary.main} />
                  </Box>
                : <></>
              }
              <Box>
                <Typography color="oxfordBlue" fontSize={12} fontWeight={700} sx={{ wordBreak: 'break-all' }} >
                  { selectedAttachment?.name ? selectedAttachment?.name : "Sin nombre"}
                </Typography>
                <Typography {...metadataStyles}>
                  {validInitDates(selectedAttachment?.created_at) ? parseDateToLgComun2(selectedAttachment?.created_at) : "Sin fecha asignada"}
                </Typography>
                {/* {
                  isImage &&
                  <Typography {...metadataStyles}>
                    1900 por 1080 pixeles
                  </Typography>
                } */}
                {/* <Typography {...metadataStyles}>
                  965 kb
                </Typography> */}
                <Typography color="teal" fontSize={12} fontWeight={600} sx={{ cursor: 'pointer', width: 'fit-content' }} onClick={() => window.open(selectedAttachment.url)}>
                  {t("information.download")}
                </Typography>
              </Box>
            </Stack>

            {
              selectedAttachment?.comment && (
                <>
                  <Typography color="secondary" fontSize={12} fontWeight={600} marginBottom={.8}>
                    Descripcion del documento
                  </Typography>
                  <Typography fontSize={16} color="oxfordBlue" borderBottom={`1px solid ${theme.palette.blueGray200.main}`}>
                    {selectedAttachment.comment}
                  </Typography>
                </>
              )
            }
          </>
        )
      }
    </Box>
  )
}

function ImagePreview({ src, scale }) {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const [start, setStart] = useState({ x: 0, y: 0 });

  const boxRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    if (!boxRef.current || !imgRef.current) return;

    const boxRect = boxRef.current.getBoundingClientRect();
    const imgWidth = imgRef.current.naturalWidth * scale;
    const imgHeight = imgRef.current.naturalHeight * scale;

    // Ajustamos los límites de desplazamiento
    const maxX = Math.max(0, (imgWidth - boxRect.width) / 2);
    const maxY = Math.max(0, (imgHeight - boxRect.height) / 2);

    setPosition((prev) => ({
      x: Math.max(-maxX, Math.min(maxX, prev.x)),
      y: Math.max(-maxY, Math.min(maxY, prev.y)),
    }));
  }, [scale]);

  useEffect(() => {
    if (dragging) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    } else {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    }

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [dragging]);

  const handleMouseDown = (event) => {
    event.preventDefault();
    setDragging(true);
    setStart({ x: event.clientX - position.x, y: event.clientY - position.y });
  };

  const handleMouseMove = (event) => {
    if (!dragging || !boxRef.current || !imgRef.current) return;

    const boxRect = boxRef.current.getBoundingClientRect();
    const imgWidth = imgRef.current.naturalWidth * scale;
    const imgHeight = imgRef.current.naturalHeight * scale;

    // Ajustamos los límites para que la imagen cubra siempre el Box
    const maxX = Math.max(0, (imgWidth - boxRect.width) / 2);
    const maxY = Math.max(0, (imgHeight - boxRect.height) / 2);

    let newX = event.clientX - start.x;
    let newY = event.clientY - start.y;

    // Restringir los bordes de la imagen al Box
    newX = Math.max(-maxX, Math.min(maxX, newX));
    newY = Math.max(-maxY, Math.min(maxY, newY));

    setPosition({ x: newX, y: newY });
  };

  const handleMouseUp = () => {
    setDragging(false);
  };

  return (
    <Box
      ref={boxRef}
      maxHeight={300}
      width="100%"
      overflow="hidden"
      position="relative"
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{
        userSelect: "none",
        // cursor: dragging ? "grabbing" : "grab",
        backgroundColor: "black",
      }}
      // onMouseDown={handleMouseDown}
    >
      <img
        ref={imgRef}
        key={src}
        src={src}
        alt="preview"
        draggable={false}
        onLoad={()=>{}}
        style={{
          transform: `scale(${scale}) translate(${position.x}px, ${position.y}px)`,
          transition: dragging ? "none" : "transform 0.1s ease-out",
          width: "100%",
          height: "100%",
          maxWidth: "100%",
        }}
      />
    </Box>
  );
}